import { useQuery, useMutation, useQueryClient } from 'react-query';
import { 
  createCategory, 
  deleteCategory, 
  getCategories,
  getCategoriesByLanguage,  
  getCategoryByName, 
  updateCategory 
} from '../../api/categories/categoriesApi';

export const useCategories = (type, language = null) => {
  const queryClient = useQueryClient();
  
  const { data, isLoading, error } = useQuery(
    ['categories', type, language],
    () => language ? getCategoriesByLanguage(type, language) : getCategories(type, language),
    {
      enabled: !!type,
      onError: (error) => {
        console.error('Failed to fetch categories:', error);
      }
    }
  );
  
  const createCategoryMutation = useMutation(
    ({ name, language = 'english' }) => createCategory({ type, name, language }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['categories', type, language]);
      },
      onError: (error) => {
        console.error('Failed to create category:', error);
      }
    }
  );
  
  const updateCategoryMutation = useMutation(
    ({ categoryId, name, language }) => updateCategory({ type, categoryId, name, language }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['categories', type, language]);
      },
      onError: (error) => {
        console.error('Failed to update category:', error);
      }
    }
  );
  
  const deleteCategoryMutation = useMutation(
    (categoryId) => deleteCategory({ type, categoryId }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['categories', type, language]);
      },
      onError: (error) => {
        console.error('Failed to delete category:', error);
      }
    }
  );
  
  return {
    categories: data,
    isLoading,
    error: error?.response?.data?.message || error?.message,
    createCategory: createCategoryMutation.mutate,
    updateCategory: updateCategoryMutation.mutate,
    deleteCategory: deleteCategoryMutation.mutate
  };
};

export const useCategoryByName = (type, name, language = null) => {
  const { data, isLoading, error } = useQuery(
    ['category', type, name, language],
    () => getCategoryByName({ type, name, language }),
    {
      enabled: !!type && !!name,
      onError: (error) => {
        console.error('Failed to fetch category by name:', error);
      }
    }
  );
  
  return {
    category: data,
    isLoading,
    error: error?.response?.data?.message || error?.message
  };
};